import {
  SteeringWalletArchiveMutationOptions,
  SteeringWalletCreateMutationOptions,
  SteeringWalletUpdateMutationOptions,
  SteeringWalletActivateMutationOptions,
  SteeringWalletDeactivateMutationOptions,
  useSteeringWalletArchiveMutation,
  useSteeringWalletCreateMutation,
  useSteeringWalletUpdateMutation,
  useWalletSteeringSurveyCreateMutation,
  useWalletSteeringSurveyUpdateMutation,
  WalletSteeringSurveyCreateMutationOptions,
  WalletSteeringSurveyUpdateMutationOptions,
  useSteeringWalletActivateMutation,
  SteeringWalletUnarchiveMutationOptions,
  useSteeringWalletUnarchiveMutation,
  useSteeringWalletDeactivateMutation,
  SurveyOfferDeleteMutationOptions,
  useSurveyOfferDeleteMutation,
  SurveyOfferCreateMutationOptions,
  useSurveyOfferCreateMutation,
  SurveyOfferUpdateMutationOptions,
  useSurveyOfferUpdateMutation,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useSteeringWalletCreate = (baseOptions?: SteeringWalletCreateMutationOptions) =>
  useMutation(useSteeringWalletCreateMutation, baseOptions);

export const useSteeringWalletUpdate = (baseOptions?: SteeringWalletUpdateMutationOptions) =>
  useMutation(useSteeringWalletUpdateMutation, baseOptions);

export const useSteeringWalletArchive = (baseOptions?: SteeringWalletArchiveMutationOptions) =>
  useMutation(useSteeringWalletArchiveMutation, baseOptions);

export const useSteeringWalletUnarchive = (baseOptions?: SteeringWalletUnarchiveMutationOptions) =>
  useMutation(useSteeringWalletUnarchiveMutation, baseOptions);

export const useSteeringWalletActivate = (baseOptions?: SteeringWalletActivateMutationOptions) =>
  useMutation(useSteeringWalletActivateMutation, baseOptions);

export const useSteeringWalletDeactivate = (
  baseOptions?: SteeringWalletDeactivateMutationOptions,
) => useMutation(useSteeringWalletDeactivateMutation, baseOptions);

export const useWalletSteeringSurveyCreate = (
  baseOptions?: WalletSteeringSurveyCreateMutationOptions,
) => useMutation(useWalletSteeringSurveyCreateMutation, baseOptions);

export const useWalletSteeringSurveyUpdate = (
  baseOptions?: WalletSteeringSurveyUpdateMutationOptions,
) => useMutation(useWalletSteeringSurveyUpdateMutation, baseOptions);

export const useSurveyOfferCreate = (baseOptions?: SurveyOfferCreateMutationOptions) =>
  useMutation(useSurveyOfferCreateMutation, baseOptions);

export const useSurveyOfferUpdate = (baseOptions?: SurveyOfferUpdateMutationOptions) =>
  useMutation(useSurveyOfferUpdateMutation, baseOptions);

export const useSurveyOfferDelete = (baseOptions?: SurveyOfferDeleteMutationOptions) =>
  useMutation(useSurveyOfferDeleteMutation, baseOptions);
